export default "__VITE_ASSET__54881548__"